import {
  put, takeLatest, takeEvery, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import CFV2Actions, { cfV2ActionTypes } from '@Actions/configurations/cfV2Actions';
import CFV2Services from '../../services/configurations/cfV2Services';

function* _createCFV2(action) {
  try {
    yield put(CFV2Actions.createCFV2Loading(true));
    const cfV2 = yield CFV2Services.createCFV2(action.payload);
    if (cfV2.success) {
      yield put(TrackerActions.trackAction(cfV2ActionTypes.CREATE_CFV2.SUCCESS, {
        request: action?.payload,
        response: cfV2,
      }));
      notification.open({
        type: 'success',
        message: 'Custom Field successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(cfV2);
    } else {
      notification.open({
        type: 'error',
        message: cfV2.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CFV2Actions.createCFV2Loading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(CFV2Actions.createCFV2Loading(false));
    yield put(TrackerActions.trackAction(cfV2ActionTypes.CREATE_CFV2.ERROR, {
      request: action,
      error,
    }));
  }
}

function* createCFV2() {
  yield takeLatest(cfV2ActionTypes.CREATE_CFV2.REQUEST, _createCFV2);
}

function* _updateCFV2(action) {
  try {
    yield put(CFV2Actions.updateCFV2Loading(true));
    const cfV2 = yield CFV2Services.updateCFV2(action.payload);
    if (cfV2.success) {
      yield put(TrackerActions.trackAction(cfV2ActionTypes.UPDATE_CFV2.SUCCESS, {
        request: action?.payload,
        response: cfV2,
      }));
      notification.open({
        type: 'success',
        message: 'Custom Field successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(CFV2Actions.updateCFV2Loading(false));
    } else {
      notification.open({
        type: 'error',
        message: cfV2?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(CFV2Actions.updateCFV2Loading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(CFV2Actions.updateCFV2Loading(false));
    yield put(TrackerActions.trackAction(cfV2ActionTypes.UPDATE_CFV2.ERROR, {
      request: action,
      error,
    }));
  }
}

function* updateCFV2() {
  yield takeLatest(cfV2ActionTypes.UPDATE_CFV2.REQUEST, _updateCFV2);
}

function* _getCFV2(action) {
  const { payload, callback } = action;
  try {
    CFV2Actions.getCFV2Success(null, payload.entityName);
    yield put(CFV2Actions.getCFV2Loading(true, payload.entityName));
    const getCFV2Data = yield CFV2Services.getCFV2(payload.orgId, payload.entityName, payload.cfV2Id, payload.page, payload.limit, payload.isGlobal);
    if (payload?.isGlobal) {
      yield put(CFV2Actions.getCfGlobalSuccess({
        data: {
          ...getCFV2Data,
        },
      },
        payload.entityName));
    }
    yield put(CFV2Actions.getCFV2Success({
      data: {
        ...getCFV2Data,
      },
    },
      payload.entityName));
    yield put(CFV2Actions.getCFV2Loading(false, payload.entityName));
  } catch (error) {
    yield put(CFV2Actions.getCFV2Loading(false, payload.entityName));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cfV2ActionTypes.GET_CFV2.ERROR, {
      request: action,
      error,
    }));
  }
}

function* getCFV2() {
  yield takeEvery(cfV2ActionTypes.GET_CFV2.REQUEST, _getCFV2);
}

function* _getCFV2ById(action) {
  try {
    yield put(CFV2Actions.getCFV2ByIdLoading(true));
    const {
      orgId, cfV2Id,
    } = action;
    const selectedCFV2 = yield CFV2Services.getCFV2(orgId, '', cfV2Id);
    yield put(CFV2Actions.getCFV2ByIdSuccess(selectedCFV2));
    yield put(CFV2Actions.getCFV2ByIdLoading(false));
  } catch (error) {
    yield put(CFV2Actions.getCFV2ByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cfV2ActionTypes.GET_CFV2_BY_ID.ERROR, {
      request: action,
      error,
    }));
  }
}

function* getCFV2ById() {
  yield takeLatest(cfV2ActionTypes.GET_CFV2_BY_ID.REQUEST, _getCFV2ById);
}

function* _deleteCFV2(action) {
  try {
    yield put(CFV2Actions.deleteCFV2Loading(true));
    const {
      orgId, cfV2Id, callback,
    } = action;
    const deletedGrn = yield CFV2Services.deleteCFV2(orgId, cfV2Id);

    if (deletedGrn.success) {
      notification.open({
        type: 'success',
        message: 'Custom Field successfully deleted',
        duration: 4,
        placement: 'top',
      });
      callback();
    } else {
      notification.open({
        type: 'error',
        message: deletedGrn?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(CFV2Actions.deleteCFV2Loading(false));
  } catch (error) {
    yield put(CFV2Actions.deleteCFV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cfV2ActionTypes.DELETE_CFV2.ERROR, {
      request: action,
      error,
    }));
  }
}

function* deleteCFV2() {
  yield takeLatest(cfV2ActionTypes.DELETE_CFV2.REQUEST, _deleteCFV2);
}

function* _getDocCFV2(action) {
  const { payload, callback } = action;
  try {
    CFV2Actions.getDocCFV2Success(null);
    yield put(CFV2Actions.getDocCFV2Loading(true, payload.entityName));
    const getDocCFV2Data = yield CFV2Services.getDocCFV2(payload.orgId, payload.entityName);
    yield put(CFV2Actions.getDocCFV2Success({
      data: {
        ...getDocCFV2Data,
      },
    }, payload.entityName.includes(',')
      ? payload.entityName.split(',')[0]
      : payload.entityName));
    if (callback && getDocCFV2Data.success) {
      callback({
        data: {
          ...getDocCFV2Data,
        },
      });
    }
    yield put(CFV2Actions.getDocCFV2Loading(false, payload.entityName));
  } catch (error) {
    yield put(CFV2Actions.getDocCFV2Loading(false, payload.entityName));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(cfV2ActionTypes.GET_DOC_CFV2.ERROR, {
      request: action,
      error,
    }));
  }
}

function* getDocCFV2() {
  yield takeEvery(cfV2ActionTypes.GET_DOC_CFV2.REQUEST, _getDocCFV2);
}

export default function* cfV2Saga() {
  yield all([
    createCFV2(), getCFV2(), updateCFV2(), getCFV2ById(), deleteCFV2(), getDocCFV2(),
  ]);
}
